<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Project ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getKategori"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :tabbedTransactional="true"
        :loading="loading"
        title="PP Credit Card Claim List"
        createLink="klaimCCPpCreate"
        manifestLink="manifestKlaimCCPp"
        editLink="klaimCCPpEdit"
        draftEditLink="klaimDraftCCPpEdit"
        :dataList="searching"
        :draftList="draftList"
        :price="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "ListKlaimCCPp",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      draftList: [],
      kategori: undefined,
      searchDate: null,
      search: "",
      status: undefined,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            (obj.searchQ !== null ? obj.searchQ.toLowerCase() : "").indexOf(
              this.search.toLowerCase()
            ) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tanggal === filter);
      }

      if (this.kategori) {
        output = output.filter((item) => {
          return item.kategori === self.kategori;
        });
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      const laporan = axios({
        method: "get",
        url: this.$serviceUrl + "klaim_cc_pp",
        params: {
          tlc: this.getAuth.username,
          jenis: "Laporan",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const draft = axios({
        method: "get",
        url: this.$serviceUrl + "klaim_cc_pp",
        params: {
          tlc: this.getAuth.username,
          jenis: "Draft",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          laporan.catch(() => {
            return null;
          }),
          draft.catch(() => {
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {
            response[0].data.data.forEach((data) => {
              this.dataList.push({
                title: data.no_klaim,
                searchQ:
                  data.no_klaim +
                  " " +
                  data.kode_project +
                  " " +
                  data.allocation +
                  " " +
                  this.formatCurrency(data.currency, data.total_pemakaian)
                    .toString()
                    .toString()
                    .toLowerCase(),
                timeline: JSON.parse(data.status_app),
                unread: data.unread == "1" ? true : false,
                subdesc: [
                  [
                    {
                      label: moment(data.tanggal).format(
                        this.getDefaultDateFormat
                      ),
                      value: "",
                    },
                  ],
                  [
                    {
                      label: this.formatCurrency(
                        data.currency,
                        data.total_pemakaian
                      ),
                      value: "",
                    },
                  ],
                ],
                status: data.status,
                tanggal: data.tanggal,
                kategori: data.kategori,
                id: data.id_klaim_cc_pppd,
                price: data.grand_total,
                cancelStatus: data.cancel_sts
                  ? data.cancel_sts == 1
                    ? "Canceled"
                    : null
                  : null,
              });
            });
          } else {
            this.dataList = [];
          }
          if (response[1] !== undefined) {
            response[1].data.data.forEach((data) => {
              this.draftList.push({
                title: data.no_sppd,
                subdesc: [
                  data.kode_project,
                  data.allocation,
                  moment(data.tanggal).format(this.getDefaultDateFormat),
                  data.deskripsi,
                ],
                status: data.status,
                id: data.id_klaim_cc_pppd_draft,
                price: data.grand_total,
                mata_uang: data.currency
              });
            });
          } else {
            this.draftList = [];
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "klaimccpp",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
          this.fetchData();
          this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>